import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="duty-shift-calendar"
export default class extends Controller {
  connect() {
    this.scrollToToday()
  }

  scrollToToday() {
    const todayRow = this.element.querySelector(".cell.today")
    if (todayRow) {
      todayRow.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }
  
}
